import React from "react";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import Link from "next/link";
import Slider from "react-slick";
import { useRouter } from "next/router";
import { FacebookShareButton, TwitterShareButton } from "react-share";

import { ASSETS_URL, PAGE_URL } from "configs/constant";

import { formatDate } from "@utils/helpers/formatDate";
import { formatImage } from "@utils/helpers/logic/image";

import newsItem from "@public/images/image-news-3.png";
import iconFacebook from "@public/icons/icon-facebook.svg";
import iconTwitter from "@public/icons/icon-twitter.svg";

const NewsDetails = ({ data, listNews }) => {
  const { t } = useTranslation("newsPage");
  const router = useRouter();

  const dataShareIcons = [
    {
      key: "facebook",
      button: FacebookShareButton,
      icon: iconFacebook,
    },
    {
      key: "twitter",
      button: TwitterShareButton,
      icon: iconTwitter,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: listNews?.length > 3 ? 3 : 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: listNews?.length > 2 ? 2 : 1,
        },
      },
      {
        breakpoint: 576.01,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="news-details">
      <div className="news-details__header">
        <div
          className="news-details__header__content"
          style={{
            backgroundImage: `url(${ASSETS_URL}/${formatImage(data?.image)})`,
          }}
        >
          <h1>{t("title")}</h1>
        </div>
      </div>

      <div className="news-details__container">
        <div className="news-details__container__content">
          <div className="news-details__container__content--title">
            <h2>{data?.title || ""}</h2>
            <div className="info">
              {data?.newsCategory?.[0]?.name && (
                <span>{data?.newsCategory?.[0]?.name || ""}</span>
              )}
              <span>
                {formatDate(data?.startDate ? data?.startDate : data?.createAt)}
              </span>
            </div>
          </div>

          <Image
            src={`${ASSETS_URL}/${formatImage(data?.image)}`}
            alt="hidden-image"
            width={200}
            height={0}
            className="news-details__container__content--hidden-image"
          />
          <div
            className="news-details__container__content--content"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />

          <div className="news-details__container__content--footer">
            {dataShareIcons?.map((item) => (
              <item.button key={item?.key} url={`${PAGE_URL}${router.asPath}`}>
                <Image
                  src={item?.icon}
                  width={24}
                  height={24}
                  alt={item?.key}
                />
              </item.button>
            ))}
          </div>

          <div className="news-details__container__content--relate">
            <h2>{t("relateTo")}</h2>

            <div className="slider">
              <Slider {...settings}>
                {listNews?.map((i) => (
                  <div className="item" key={i?.id || ""}>
                    <Link href={i?.titleSlug || ""}>
                      <a>
                        <div className="image">
                          <Image
                            src={
                              i?.image?.length > 0
                                ? `${ASSETS_URL}/${formatImage(i?.image)}`
                                : newsItem
                            }
                            layout="fill"
                            alt="image"
                            objectFit="cover"
                          />
                        </div>
                      </a>
                    </Link>

                    <p>
                      {i?.newsCategory?.[0]?.name && (
                        <span>{i?.newsCategory?.[0]?.name || ""}</span>
                      )}{" "}
                      <span>
                        {formatDate(i?.startDate ? i?.startDate : i?.createAt)}
                      </span>
                    </p>

                    <Link href={i?.titleSlug || ""}>
                      <h3>{i?.title || ""}</h3>
                    </Link>
                    <Link href={i?.titleSlug || ""}>
                      <a>{t("more")}</a>
                    </Link>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetails;
